import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import {
  deleteElement,
  updateIndicatorsDates,
} from "../../../apis/apiDashboard";
import "./indicators.scss";
import { useTranslation } from "react-i18next";
import { Row, Col } from "react-bootstrap";
import { MCTooltip } from "../../MainComponents/Tooltip/Tooltip";
import Form from "react-bootstrap/Form";
import { Loading } from "../../Loading/String/Loading";
import { Box, Stack, Typography, useTheme } from "@mui/material";

export const Indicators = ({
  indicatorsData,
  stateLoading = null,
  right = false,
}) => {
  const [t] = useTranslation("dashboard");
  const { gTheme } = useSelector((state) => state.theme);
  const theme = gTheme === "dark" ? "dark" : "light";
  const [selectedValue, setSelectedValue] = useState(365);
  // State de la lista de indicadores
  const [indicators, setIndicators] = useState([]);

  const [deleting, setDeleting] = useState("");
  const [yearsList, setYearsList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (indicatorsData && typeof indicatorsData === "object" && !Array.isArray(indicatorsData)) {
      setIndicators(Object.values(indicatorsData));
    }
  }, [indicatorsData]);

  // Eliminar un indicador
  const deleteIndicator = async (path) => {
    setDeleting(path);

    const response = await deleteElement({ path });
    if (stateLoading !== null && response !== undefined) stateLoading(true);
  };

  useEffect(() => {
    setIsLoading(true);
  }, [selectedValue]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await updateIndicatorsDates("lastandFirstValue");

        const firstDate = response.data.first_report?.created_at;
        const lastDate = response.data.last_report?.created_at;

        let years = [];
        if (firstDate && lastDate) {
          const firstYear = new Date(firstDate).getFullYear();
          const lastYear = new Date(lastDate).getFullYear();
          years = Array.from(
            { length: lastYear - firstYear + 1 },
            (_, i) => firstYear + i,
          );
        } else {
          // Si no hay datos, solo se usa el año actual
          years = [new Date().getFullYear()];
        }

        setYearsList(years);

        const fetchIndicators = async (days) => {
          try {
            const response = await updateIndicatorsDates(days);
            if (response?.data && typeof response.data === "object" && !Array.isArray(response.data)) {
              setIndicators(Object.values(response.data));
            }
          } catch (error) {
            console.error("Error fetching indicators:", error);
          }
        };

        if (
          Object.values(indicatorsData).length > 0 &&
          Object.values(indicatorsData)[0]?.days_applied !== undefined
        ) {
          const daysApplied = Object.values(indicatorsData)[0]?.days_applied;

          if (daysApplied > 365) {
            setSelectedValue(daysApplied);
            await fetchIndicators(daysApplied);
          } else {
            setSelectedValue(365);
            await fetchIndicators(364);
          }
        } else {
          setSelectedValue(365);
          await fetchIndicators(364);
        }

        setIsLoading(false);
      } catch (error) {
        console.error("Error al actualizar indicadores:", error);
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleChangeyear = async (event) => {
    const newValue = event.target.value;
    const newValueMinus365 = newValue - 365;
    setSelectedValue(newValue);

    try {
      const response = await updateIndicatorsDates(newValue);
      const data = response.data;

      if (data && typeof data === "object" && !Array.isArray(data)) {
        setIndicators(Object.values(data));
      }
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching indicators:", error);
    }
  };

  return (
    <>
      <div className="dyTheme1 rounded indicators-content d-flex justify-content-between align-items-center">
        <Stack
          className={` border-bottom`}
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          py={0.5}
          px={1.5}
          flexDirection="row"
          flexWrap="wrap"
          sx={{ width: "100%" }}
        >
          <Typography>{t("indicators.title")}</Typography>
          <Box maxWidth="20vw">
            <MCTooltip text={t("Graphics.get_results")} position="top">
              <Form.Select
                size="sm"
                value={selectedValue}
                onChange={handleChangeyear}
              >
                {yearsList
                  .slice()
                  .reverse()
                  .map((year) => {
                    const firstDayOfYear = new Date(year, 0, 1);
                    const today = new Date();
                    const daysDifference = Math.floor(
                      (today - firstDayOfYear) / (1000 * 3600 * 24),
                    );

                    return (
                      <option key={year} value={daysDifference}>
                        {year}
                      </option>
                    );
                  })}
              </Form.Select>
            </MCTooltip>
          </Box>
        </Stack>

        {!isLoading ? (
          !right ? (
            indicators.length > 0 && (
              <>
                {indicators.map((indicatorItem, index) => {
                  return (
                    <div key={index} className={`indicator-body ${theme}`}>
                      <div className={`indicator-header ${theme}`}>
                        <div className="indicator-title">
                          <h6>
                            {indicatorItem.path === deleting
                              ? `${t("indicators.deleting")}...`
                              : indicatorItem.title}
                          </h6>
                          <div className={`indicator-options ${theme}`}>
                            <DropdownButton
                              key="end"
                              id="dropdown-button-drop-end"
                              drop="end"
                              title="ooo"
                            >
                              <Dropdown.Item
                                eventKey="4"
                                onClick={() =>
                                  deleteIndicator(indicatorItem.path)
                                }
                              >
                                {t("indicators.delete")}
                              </Dropdown.Item>
                            </DropdownButton>
                          </div>
                        </div>
                        <hr />
                        <div className={`indicator-count ${theme}`}>
                          <span>{indicatorItem.data[0].length}</span>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </>
            )
          ) : (
            indicators.length > 0 && (
              <>
                {indicators.map((indicatorItem, index) => (
                  <>
                    <Row>
                      <div>
                        <h4>{indicatorItem.title}</h4>
                      </div>
                    </Row>
                    <Row>
                      <div className={`indicator-count-right ${theme}`}>
                        <span>{indicatorItem.data[0].length}</span>
                      </div>
                    </Row>
                  </>
                ))}
              </>
            )
          )
        ) : (
          <div className="dyTheme1 dyBorder1 p-sm-4 reportsTable">
            <Loading />
          </div>
        )}
        {!indicators.length > 0 && (
          <Col
            sm={12}
            className="d-flex justify-content-center align-items-center"
          >
            <div className={`indicator-body ${theme}`}>
              {t("indicators.empty")}
            </div>
          </Col>
        )}
      </div>
    </>
  );
};
